import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-setting-market-inspection',
  templateUrl: './setting-market-inspection.component.html',
  styleUrls: ['./setting-market-inspection.component.css']
})
export class SettingMarketInspectionComponent implements OnInit {

  public requireGpsForWarning: boolean = false;
  public isLoading: boolean = false;

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.getMarketInspectionSetting();
  }

  getMarketInspectionSetting() {
    // TODO: Call real API to get setting here when backend is ready
    // Mocking API call
    this.isLoading = true;
    setTimeout(() => {
      this.requireGpsForWarning = false; // Mock data
      this.isLoading = false;
    }, 500);
  }

  changeRequireGps(event: any) {
    this.requireGpsForWarning = event.target.checked;
    this.saveSetting();
  }

  saveSetting() {
    // TODO: Call real API to save setting here when backend is ready
    const body = {
      require_gps: this.requireGpsForWarning
    };
    
    // Mocking API response
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
      this.toastr.success('Cập nhật cấu hình kiểm tra thị trường thành công', this.translate.instant('THONG_BAO'), {
        timeOut: 4000, positionClass: 'toast-top-right'
      });
    }, 500);
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/setting-market-inspection/setting-market-inspection.component.ts